import { MasonrySectionHeaderRenderer } from '@leagueplatform/masonry-renderers';

export const RichTextSectionHeaderRenderer: typeof MasonrySectionHeaderRenderer =
  (
    { css, ...props }, // eslint-disable-line react/prop-types
  ) => (
    <MasonrySectionHeaderRenderer
      {...props}
      css={{
        ...css,
        '.GDS-utility-text': {
          color: '$onSurfaceTextSubdued',
          '& strong': {
            color: '$onSurfaceTextPrimary',
            fontWeight: 700,
          },
        },
        '& ul': {
          paddingInlineStart: '$two',
        },
      }}
    />
  );
